/* eslint-disable react/jsx-props-no-spreading */
import styled from "@emotion/styled";
import {
  BulletList,
  BulletListBulletIconVariants,
  BulletListVariants,
  type BulletListProps,
  Spacings,
} from "@polestar/component-warehouse-react";
import React, { type FC } from "react";

const StyledBulletList = styled(BulletList)`
  margin-bottom: ${Spacings.large};
`;

const ContentUnorderedList: FC<BulletListProps> = ({ children, ...props }) => {
  return (
    <StyledBulletList
      as="ul"
      bulletIcon={BulletListBulletIconVariants.roundClosed}
      variant={BulletListVariants.bullets}
      {...props}
    >
      {children}
    </StyledBulletList>
  );
};

export default ContentUnorderedList;
